import { createAction, createReducer } from 'redux-act'
import { combineReducers } from 'redux'

export const ROOT_ID = 'gfy-root';
export const BASE_NAME = '';
export const timezone = 'Europe/Tallinn';
export const localStorageKey = 'gratify-cart-settings';

let fallback = {};

export const getLocalStorageKey = () => {
  return localStorageKey;
  //TODO: figure out how to use App ID in the localstorage key
  // try {
  //   return `${localStorageKey}-${window.gratify.appId}`;
  // } catch(e) {
  //   return localStorageKey;
  // }
};

export const saveConfig = (key, value) => {
  try {
    window.localStorage.setItem(`${getLocalStorageKey()}-${key}`, JSON.stringify(value));
  } catch(e) {
    fallback[key] = value;
  }
};

export const retrieveConfig = (key) => {
  try {
    return JSON.parse(window.localStorage.getItem(`${getLocalStorageKey()}-${key}`));
  } catch(e) {
    return fallback[key];
  }
};

export const clearConfig = (key) => {
  try {
    window.localStorage.removeItem(`${getLocalStorageKey()}-${key}`);
  } catch(e) {
    delete fallback[key];
  }
};



export const actions = {
  setCartId: createAction('set active cart id', (id) => ({id})),
  clearActiveCart: createAction('clear active cart'),
  setActiveShopId: createAction('set active shop id', (id) => ({id})),
  addToCart: createAction('add items to cart', (items) => ({items})),
  setInitialContact: createAction('set initial contact', (contact) => ({contact})),
  addCartMetadata: createAction('add cart metadata', (metadata, clear=false) => ({metadata, clear})),
  setCustomerToken: createAction('set customer token', (token) => ({token})),
  clearCustomerToken: createAction('clear customer token', (token) => ({token})),
  setUserTokens: createAction('set user tokens', (tokens) => ({tokens})),
  clearUserTokens: createAction('clear user tokens'),
  setConfig: createAction('set config', (config) => ({...config})),
  setRedirectUrl: createAction('set redirect url', (url) => ({url})),
  clearRedirectUrl: createAction('set redirect url'),
  setCartDefaults: createAction('set cart defaults', (defaults) => ({defaults})),
  addItemsToCart: createAction('add items to cart', (items) => ({items})),
  setDefaultLanguage: createAction('set default language', (language) => ({language})),
  setLanguage: createAction('set language', (language) => ({language})),
};

let defaultGratifyServer = 'https://gratify.eu/';

if(typeof GRATIFY_API !== 'undefined' && GRATIFY_API) {
  defaultGratifyServer = GRATIFY_API;
}

const createSetConfigHandler = (key) => {
  return {
    [actions.setConfig]: (_, payload) => {
      const value = (payload || {})[key];
      if(value) {
        return value
      }

      return _;
    }
  }
}

const base = createReducer({
  ...createSetConfigHandler('base'),
}, defaultGratifyServer);
const api = createReducer({
  ...createSetConfigHandler('api'),
}, `${defaultGratifyServer}api/`);
const auth = createReducer({
  ...createSetConfigHandler('auth'),
}, `${defaultGratifyServer}api-auth/`);
const customerTokenUrls = createReducer({
  ...createSetConfigHandler('customerTokenUrls'),
}, {
  obtain: `${defaultGratifyServer}customers/obtain-customer-token/`,
  verify: `${defaultGratifyServer}customers/verify-customer-token/`,
  refresh: `${defaultGratifyServer}customers/refresh-customer-token/`,
  upgrade: `${defaultGratifyServer}customers/upgrade-customer-token/`,
});
const customerToken = createReducer({
  ...createSetConfigHandler('customerToken'),
  [actions.setCustomerToken]: (_, payload) => {
    if(payload.token) {
      return payload.token;
    }

    return _;
  },
  [actions.clearCustomerToken]: () => {
    return null;
  }
}, retrieveConfig('customerToken') || null);
const userTokens = createReducer({
  ...createSetConfigHandler('userTokens'),
  [actions.setUserTokens]: (_, payload) => {
    if(payload.tokens) {
      return payload.tokens;
    }

    return _;
  },
  [actions.clearUserTokens]: () => {
    return null;
  }
}, retrieveConfig('userTokens') || null);
const token = createReducer({
  ...createSetConfigHandler('token'),
}, null);
const account = createReducer({
  ...createSetConfigHandler('account'),
}, null);
const appId = createReducer({
  ...createSetConfigHandler('appId'),
}, null);
const clearCartOnClose = createReducer({
  ...createSetConfigHandler('clearCartOnClose'),
}, false);
const requestedLanguage = createReducer({
  ...createSetConfigHandler('language'),
}, null);
const language = createReducer({
  [actions.language]: (state, payload) => {
    return payload.language;
  }
}, null);
const defaultLanguage = createReducer({
  [actions.setDefaultLanguage]: (state, payload) => {
    return payload.language;
  }
}, 'et');
const shopId = createReducer({
  ...createSetConfigHandler('shopId'),
  [actions.setActiveShopId]: (state, payload) => {
    const { id } = payload;
    return id || state;
  }
}, null);
const localeConfig = createReducer({
  ...createSetConfigHandler('localeConfig')
}, null);
const cartId = createReducer({
  ...createSetConfigHandler('cartId'),
  [actions.setCartId]: (state, payload) => {
    const { id } = payload;
    return id || state;
  },
  [actions.clearActiveCart]: () => null
}, retrieveConfig('cartId') || null);

const cartFloaterEnabled = createReducer({
  ...createSetConfigHandler('cartFloaterEnabled'),
}, true);

const cartFloatAlignment = createReducer({
  ...createSetConfigHandler('cartFloatAlignment'),
}, 'topRight');

const redirectAfterAuth = createReducer({
  [actions.setRedirectUrl]: (state, payload) => (payload.url),
  [actions.clearRedirectUrl]: () => (null),
  [actions.clearUserTokens]: () => (null),
}, retrieveConfig('redirectAfterAuth') || null);

const cartDefaults = createReducer( {
  [actions.setCartDefaults]: (state, payload) => ({...state, ...(payload.defaults || {})})
}, {});

export const reducer = combineReducers({
  base,
  api,
  auth,
  customerTokenUrls,
  customerToken,
  userTokens,
  token,
  defaultLanguage,
  requestedLanguage,
  language,
  account,
  appId,
  shopId,
  localeConfig,
  cartId,
  cartFloaterEnabled,
  cartFloatAlignment,
  clearCartOnClose,
  redirectAfterAuth,
  cartDefaults
});

export const selector = state => state.config;
